import Combobox from "@github/combobox-nav"
import { type ActionEvent, Controller } from "@hotwired/stimulus"

import { hasFocusedElement } from "@/helpers/utils"

export default class extends Controller {
  declare private combobox: Combobox

  static targets = ["input", "listbox"]
  declare readonly inputTarget: HTMLInputElement
  declare readonly listboxTarget: HTMLOListElement

  disconnect(): void {
    this.combobox?.destroy()
  }

  listboxTargetConnected(listbox: HTMLOListElement): void {
    if (!listbox.hidden) {
      this.start()
    }
  }

  start(): void {
    this.combobox?.destroy()

    this.combobox = new Combobox(this.inputTarget, this.listboxTarget)
    this.combobox.start()
    this.listboxTarget.hidden = false
  }

  startOrStop({ relatedTarget }: FocusEvent): void {
    // Controller element can contain both input and "clear" button, each of which can gain/lose
    // focus. Keep combobox open if focus is still within controller element itself.
    if (hasFocusedElement(this.element, relatedTarget)) {
      this.start()
    } else {
      this.stop()
    }
  }

  stop(event?: ActionEvent): void {
    this.combobox?.stop()

    this.listboxTarget.hidden = !event || event.params.hideListbox
  }
}
